export enum Notification {
  SeatbeltToggledOn = "SEATBELT_TOGGLED_ON",
  SeatbeltToggledOff = "SEATBELT_TOGGLED_OFF",
  EngineToggledOn = "ENGINE_TOGGLED_ON",
  EngineToggledOff = "ENGINE_TOGGLED_OFF",
}
